import styled from 'styled-components'

export const HoverActions = styled.div`
  visibility: hidden;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 16px;
  cursor: pointer;
`

export const Container = styled.div`
  ${props =>
    props.smartSize &&
    `
  width: 16.7vmax;
  height: 16.7vmax;
  `}
  border-radius: 16px;
  background-size: cover;
  cursor: pointer;
  overflow: hidden;

  @media (max-width: 820px) {
    width: 31vw;
    height: 31vw;
    ${props => props.mobileGrid && `width: 47vw; height: 47vw;`}
    ${props =>
      props.mobileGallery && `width: 100%; height: auto; aspect-ratio: 1/1;`}
  }

  @media screen and (max-width: 630px) {
    width: 95vw;
    height: 95vw;

    ${props => props.mobileGrid && `width: 45vw; height: 45vw;`}
    ${props =>
      props.mobileGallery && `width: 100%; height: auto; aspect-ratio: 1/1;`}
  }
`

export const Wrapper = styled.div`
  position: relative;

  &:hover {
    ${HoverActions} {
      visibility: visible;
    }
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  position: absolute;
  right: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`

export const BottomButtonsContainer = styled(ButtonsContainer)`
  bottom: 10px;
`

export const TopButtonsContainer = styled(ButtonsContainer)`
  top: 10px;
  left: 10px;
  right: 10px;
  width: 95%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`

export const MoreButton = styled.button`
  background: transparent;
  border: none;
`

export const UserProfile = styled.div`
  width: 48px;
  height: 48px;
  align-items: center;
  display: flex;
  align-items: center;
`

export const UserAvatar = styled.img`
  border-radius: 40px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #979797;

  @media (max-width: 600px) {
    border-radius: 50%;
  }
`

export const UserName = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  vertical-align: middle;
  margin-left: 10px;
`

export const DraftTypeBanner = styled.div`
  position: absolute;
  top: 28px;
  left: 0;
  ${props =>
    props.type === 'draft' &&
    'background: linear-gradient(-270deg, #618dff 0%, #ff4f7e 100%);'}
  ${props =>
    props.type === 'challenge' &&
    'background: linear-gradient(270deg, #FF9D74 0%, #FF5E6D 37.4%, #FF4F7E 74.69%, #FF6D90 100%);'}
  height: 34px;
  min-width: 120px;
  width: auto;
  padding-left: 10px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  color: #ffffff;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;

  & img {
    margin-right: 7px;
  }

  @media (max-width: 600px) {
    max-width: 120px;

    height: 30px;
    top: 13px;
    padding: 0;
    font-size: 11px;
    & img {
      margin-right: 3px;
    }
  }
`
